import React from 'react';

import type { WithDataTestid } from '@vlabs/uikit/types';

import st from './Header.module.sass';

export interface HeaderProps extends WithDataTestid {
  title?: string;
  dummySize?: number;
}

function Header({
  title = undefined,
  dummySize = 0,
  'data-testid': dataTestId = undefined,
}: HeaderProps): React.JSX.Element {
  return (
    <React.Fragment>
      <div
        className={st.Header}
        data-testid={dataTestId}
      >
        {title}
      </div>
      {!!dummySize && (
      <div
        className={st.Header}
        style={{ width: 120 * dummySize }}
      />
      )}
    </React.Fragment>
  );
}

export { Header };
